/* global ol, olgm */
import OlMapManager from '@/lib/OlMapManager'

export default {
  methods: {
    checkArgNum_(num, args) {
      const arr = [].slice.apply(args).filter(e => {
        return e !== undefined
      })
      if (arr.length < num) {
        throw Error(`checkArgNum. There should be ${num} arguments.`)
      }
    },
    initMapManager(params) {
      this.mapMgr_ = new OlMapManager()
      this.mapMgr_.initMap(params)
    },
    coordFromLonLat(coord, opt = {}) {
      const destProj = opt.destProj || 'EPSG:3857'
      return ol.proj.fromLonLat(coord, destProj)
    },
    convCoord({ lat, lon }, opt = {}) {
      const srcProj = opt.srcProj || 'EPSG:4326'
      const destProj = opt.destProj || 'EPSG:3857'
      return ol.proj.transform([lon, lat], srcProj, destProj)
    },
    convGeometry(geom, opt = {}) {
      const srcProj = opt.srcProj || 'EPSG:4326'
      const destProj = opt.destProj || 'EPSG:3857'
      return geom.clone().transform(srcProj, destProj)
    },
    addDebugClickEvent() {
      // want to see the EPSG:4326 coord of clicked point.
      this.mapMgr_.getMap().on('click', evt => {
        const [lon, lat] = ol.proj.transform(
          evt.coordinate, 'EPSG:3857', 'EPSG:4326'
        )
        console.log(`{ lat: ${lat.toFixed(6)}, lon: ${lon.toFixed(6)} },`)
        if (this.recLayerMgr) {
          this.recLayerMgr.onMapClick(evt.coordinate)
        }
      })
    },

    addMapInteraction(interaction) {
      this.mapMgr_.addMapInteraction(interaction)
    },

    getBingMapLayer() {
      // http://openlayers.org/en/v3.14.2/examples/bing-maps.html
      const styles = [
        'Road',
        'Aerial',
        'AerialWithLabels',
      ]
      const layer = new ol.layer.Tile({
        // visible: false,
        // preload: Infinity,
        source: new ol.source.BingMaps({
          key: 'AjTZgCFwpJQs_5feMLVLOWAGOYxT2ALlkniFCUvUfSrQVueWI83KqusIQaWTqy35',
          imagerySet: styles[2]
        })
      })
      layer.name = 'bing'
      return layer
    },
    getGoogleMapLayer() {
      const layer = new ol.layer.Tile({
        source: new ol.source.TileImage({
          url: 'http://mt{0-3}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}'
          // url: 'http://maps.google.com/maps/vt?pb=!1m5!1m4!1i{z}!2i{x}!3i{y}!4i256!2m3!1e0!2sm!3i375060738!3m9!2spl!3sUS!5e18!12m1!1e47!12m3!1e37!2m1!1ssmartmaps!4e0'
        })
      })
      layer.name = 'gmap'
      return layer
    },
    getOlGMGoogleMapLayer() {
      const layer = new olgm.layer.Google()
      layer.name = 'gmap'
      return layer
    },
    activateOlGM() {
      const olGM = new olgm.OLGoogleMaps({ map: this.mapMgr_.map })
      olGM.activate()
    },

    addLayer(layer, opts) {
      this.checkArgNum_(1, arguments)
      this.mapMgr_.addLayer(layer, opts)
    },
    addLayers(arr) {
      arr.forEach(e => {
        this.mapMgr_.addLayer(e.layer, e.opts)
      })
    },
    getLayer(layerName) {
      return this.mapMgr_.getLayer(layerName)
    },
    removeLayer(layerName) {
      return this.mapMgr_.removeLayer(layerName)
    },

    fitToExtent(extent, opts) {
      this.mapMgr_.view.fit(extent, opts)
    },
    updateMapSize() {
      this.mapMgr_.map.updateSize()
    },

  }
}
